var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionsMenu',_vm._b({staticClass:"h-ml-3"},'ActionsMenu',{ actionsBtnItems: _vm.actionsBtnItems },false))}
var staticRenderFns = []

export { render, staticRenderFns }